// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "bundle." + ({"95":"superfish","171":"accordion-tabs","209":"accordion","509":"mobile-menu","520":"tabs","594":"foundation"}[chunkId] || chunkId) + ".js";
};